import React, { useMemo } from "react";
import { AiOutlineEye } from "react-icons/ai";

// components
import DepositedActionMenu from "./DepositedActionMenu";
import ServerDataGrid from "views/pages/manage/common/data-grid/ServerDataGrid";
import ReceiptStatusChip from "../../../cash-management/components/ReceiptStatusChip";
import { getFormattedAmount } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { CourseDetailsPopupById } from "views/pages/manage/unAssigned/studentCharges/common";
const formatDate = (dateString, includeTime = false) => {
  if (!dateString) return "-";
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  if (includeTime) {
    options.hour = "2-digit";
    options.minute = "2-digit";
    options.hour12 = true;
  }
  return new Date(dateString)
    .toLocaleDateString("en-GB", options)
    .replace(",", "");
};

const DepositedList = ({
  rows,
  loading,
  pagination,
  onPageChange,
  onPageSizeChange,
  selectedIds,
  onSelectionChange,
  onViewCheque,
  openModal,
  hideModal,
  fetchTrackerTimeLine,
  onEditReceipt,
  refreshList,
  state,
  setState
}) => {

  const columns = useMemo(
    () => [
      {
        key: "psid",
        label: "PSID",
        sortable: true,
        width: 120,
        render: (value) => (
          <span
            style={{
              color: "#00B0F5",
              cursor: "pointer",
              textDecoration: "none",
            }}
            onClick={() =>
              window.open(`/#/admin/edp/studentDetails/${value}`, "_blank")
            }
          >
            {value}
          </span>
        ),
      },
      { key: "applicationId", label: "App. ID", sortable: false, width: 140 },

      { key: "studentName", label: "Student Name", sortable: true, width: 140 },

      {
        key: "bankName",
        label: "Bank Name",
        width: 120,
      },
      {
        key: "referenceNumber",
        label: "Cheque Number",
        sortable: true,
        width: 120,
      },
     {
        key: "extendedDate",
        label: "Cheque Date",
        sortable: true,
        width: 120,
        render: (value,row) => formatDate(value , false),
      },
      {
        key: "attachmentS3Key", // Using this key for the 'View' button column as per old config
        label: "Attachment",
        width: 120,
        align: "center",
        render: (_, row) => (
          <button
            className="btn btn-primary btn-sm"
            style={{ fontSize: "12px", padding: "4px 12px" }}
            onClick={() => onViewCheque(row)}
          >
            View
          </button>
        ),
      },
      { key: "term", label: "Term", width: 80, sortable: true },
      {
        key: "courseId",
        label: "Course ID",
        width: 120,
        render: (value, row) => (
          <span title={row.courseName ?? ""}>
            {value}
            <CourseDetailsPopupById
              courseId={value}
              placement="left-end"
              cta={<AiOutlineEye className="ml-2" />}
            />
          </span>
        ),
      },
      { key: "receiptNo", label: "Receipt No.", width: 200 },
      {
        key: "receiptDate",
        label: "Receipt Date On",
        sortable: true,
        width: 170,
        render: (value) => formatDate(value, true),
      },
      {
        key: "depositDate",
        label: "Deposit Date",
        width: 120,
        render: (value,row) => formatDate(value, false),
      },
         {
        key: "cancOrBncdDate",
        label: "Cancel/Bounced Date",
        width: 120,
        render: (value,row) => formatDate(value, false),
      },
      {
        key: "depositSlipNumber",
        label: "deposit slip number",
        width: 120,
      },
      { key: "createdBy", label: "Cashier ID", width: 130 },
      {
        key: "lastUpdatedOn",
        label: "Last Updated On",
        width: 180,
        render: (value) => formatDate(value, true),
      },
      {
        key: "approvedOn",
        label: "Approved On",
        width: 160,
        render: (value) => formatDate(value, true),
      },
      {
        key: "amountCollected",
        label: "Amt Collected",
        sortable: true,
        pinned: true,
        width: 150,
        align: "right",
        render: (value) => (
          <b style={{ color: "#0A942B" }}>{getFormattedAmount(value)}</b>
        ),
      },
      {
        key: "status",
        label: "Status",
        width: 140,
        pinned: true,
        render: (value, row) => (
          <ReceiptStatusChip
            status={value}
            approvalStatus={row.approvalStatus}
            row={row}
            editHandler={onEditReceipt}
            fetchTrackerTimeLine={fetchTrackerTimeLine}
            paymentType="chkl"
          />
        ),
      },
      {
        key: "action",
        label: "Action",
        width: 70,
        pinned: true,
        render: (_, row) => (
          <DepositedActionMenu
            openModal={openModal}
            hideModal={hideModal}
            refreshList={refreshList}
            row={row}
            state={state}
            setState={setState}
          />
        ),
      },
    ],
    [state]
  );

  return (
    <ServerDataGrid
      rows={rows}
      loading={loading}
      columns={columns}
      rowKey="id"
      pagination={pagination}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      selectable={false}
      selectedIds={selectedIds}
      onSelectionChange={onSelectionChange}
    />
  );
};

export default DepositedList;
